import { FoodSteakIcon } from './FoodSteakIcon';

/**
 * author: Michael Irigoyen
 * id 1A357DD0-01F0-4FF9-83D3-41B9AA22E5D1
 * name food-steak
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-steak.svg
 * tags
 * - Food / Drink 
 */
export const BeefIcon = FoodSteakIcon;
export default BeefIcon